import { cn } from "@/ds/utils";
import type { FC } from "react";
import { Link } from "react-router";

export interface NavTab {
	label: string;
	to: string;
	active: boolean;
}

export interface NavTabsProps {
	tabs: NavTab[];
	className?: string;
}

export const NavTabs: FC<NavTabsProps> = props => {
	const {
		tabs,
		className
	} = props;

	return (
		<nav className={cn("no-scrollbar overflow-x-auto", className)}>
			<div className="bg-muted text-muted-foreground inline-flex h-9 min-w-full items-center rounded-lg p-[3px] @md:min-w-0">
				{
					tabs.map(x => (
						<Link
							key={x.to}
							to={x.to}
							aria-current={x.active ? "page" : undefined}
							className={cn(
								"inline-flex h-full flex-1 items-center justify-center rounded-md border border-transparent px-3 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50",
								x.active
									? "bg-background text-foreground shadow-sm dark:border-input dark:bg-input/30"
									: "text-foreground dark:text-muted-foreground hover:text-foreground"
							)}>
							{x.label}
						</Link>
					))
				}
			</div>
		</nav>
	);
};
